import React from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { Loading } from '../Loadings/loading';

type Props = {
    unitConsumers: any[]
    loading: boolean
}

export function TableUnitConsumerModalPlant({unitConsumers, loading} : Props) {
    //const [control, setControl] = useState(false);
    
  return (
    <div className='table-responsive'>
          <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='text-muted text-start fw-bolder fs-8 text-uppercase gs-0'>
                <th className='min-w-100px'>Name</th>
                <th className='min-w-100px'>Status</th>
              </tr>
            </thead>
              {
                loading ? 
                  <tbody>
                    <tr>
                      <td colSpan={5} className="tdLoadingUnit">
                        <Loading myClass='spinner-border loadingCenterUnit' />
                      </td>
                    </tr>
                  </tbody>
                : 
                   unitConsumers.length > 0 ? (
                    unitConsumers.map((unitConsumer: any) => {
                        return (
                            <tr 
                                onClick={() =>{
                                    // if(report.status === "GERADO"){
                                    //     setMyReport(report)
                                    //     setShowCreateAppModalDetails(true)
                                    // }
                                    // else{
                                    //     setMyReport(report)
                                    //     setShowCreateAppModalView(true)
                                    // }
                                }}
                            >
                                <td>
                                    <div className='d-flex align-items-center'>
                                        <div className='symbol symbol-30px symbol-circle me-5'>
                                            <img src={toAbsoluteUrl("/media/icons/duotune/general/gen001.svg")} />
                                        </div>
                                        <div className='d-flex align-items-center'>
                                            <div className='d-flex justify-content-start flex-column'>
                                                <a href='#' className='text-dark fw-bold text-hover-primary fs-7'>
                                                    {unitConsumer.name ? unitConsumer.name : "Não encontrado. "}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <span 
                                        className={
                                            `badge badge-light-${
                                                unitConsumer.status !== null
                                                ? unitConsumer.status === "ATIVA"
                                                ? "success"
                                                : unitConsumer.status === "INATIVA"
                                                ? "danger"
                                                : "secondary"
                                            : "secondary"
                                            } fs-7 fw-semibold`
                                        }
                                        >
                                            {
                                                unitConsumer.status ? unitConsumer.status : "Não identificado"
                                            }
                                        </span>
                                </td>
                        
                            </tr>
                        )
                    })
                   )
                   :
                   (
                    <tr>
                        <td colSpan={6} style={{textAlign: 'center'}}>
                            <div className='d-flex justify-content-center' style={{padding: '2rem'}}>
                                <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                    Unidades Consumidoras não encontradas!
                                </span>
                            </div>
                        </td>
                    </tr>
                   )
              }
          </table>
        </div>
  );
}